<template>
	<div class="body">
		<div class="body-container">
			<div class="top-ctr">
				<div class="job-title">{{title}}</div>
				<el-button class="create-btn el-button--danger" type="primary"
					@click="clickCreate()">添加合作企业岗位</el-button>
			</div>

			<el-table :data="list" border stripe>
				<el-table-column label="序号" align="center" prop="index">
				</el-table-column>
				<el-table-column label="岗位（群）名称" align="center" prop="name">
				</el-table-column>
				<el-table-column label="状态" align="center" prop="description">
					<template v-slot="{ row }">
						<template v-if="acceptMap[row.name]">
							<label v-if="acceptMap[row.name] == 1"
								style="color:green">符合要求({{row.count}}个)</label>
							<label v-else
								style="color:red">不符合要求</label>
				
						</template>
						
						<label @click="clickIntro(row)" v-else style="color: blue;">待选择</label>
					</template>
				</el-table-column>
				<el-table-column label="市场岗位" align="center" prop="id">
					<template v-slot="{ row }">
						<label style="color: blue;" @click="clickIntro(row)">查看</label>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template v-slot="{ row }">
						<el-button type="primary" class="el-button--warning" size="small" @click="clickDel(row.name)"
							v-if="row.custom == 1">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">生成岗位典型工作任务</el-button>
		</div>

		<el-dialog :title="careerData.title" :visible.sync="showCareerDialog" append-to-body v-if="showCareerDialog"
			align="center" width="70%">

			<el-form :inline="true" v-if="jobParams.custom != 1">
				<el-form-item label="岗位名称">
					<el-select class="select-width" v-model="jobParams.name" :clearable=true>
						<el-option v-for="item in nameList" :key="item.name" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="公司名称">
					<el-input v-model="jobParams.company" placeholder="请输入名字" class="dialog-input" />
				</el-form-item>
				
				<el-form-item label="岗位内容">
					<el-input v-model="jobParams.content" placeholder="请输入名字" class="dialog-input" />
				</el-form-item>
				<el-form-item label="添加状态">
					<el-select class="select-width" v-model="jobParams.state">
						<el-option v-for="item in stateList" :key="item.name" :label="item.name" :value="item.state">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" icon="el-icon-search" size="medium" @click="clickSearchJob">搜
						索</el-button>
					<el-button type="primary" class="el-button--success" icon="el-icon-download" size="medium" @click="clickExport">导出</el-button>
				</el-form-item>

			</el-form>
			<div class="table-ctr">
				<el-table ref="multipleTable" :data="careerData.list" border stripe height="100%"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection">
					</el-table-column>
				<!-- 	<el-table-column label="id" align="center" prop="id">
					</el-table-column> -->
					<el-table-column label="公司" align="center" prop="company_name" min-width="1">
					</el-table-column>
					<el-table-column label="岗位名称" align="center" prop="name" min-width="1">
					</el-table-column>
					<el-table-column label="岗位描述" align="center" prop="description" min-width="5">
					</el-table-column>
				</el-table>

				<div class="pagination">
					<pagination v-show="careerData.pageData.totalCount>0" :total="careerData.pageData.totalCount"
						:page.sync="jobParams.page" :limit.sync="jobParams.pageSize" @pagination="queryJobData" />
				</div>
				
				<!-- <div class="tips-ctr">{{tips}}</div> -->
			</div>
			
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickAccept(careerData.cateData)">符合要求</el-button>
				<el-button type="primary" class="el-button--warning"
					@click="clickReject(careerData.cateData)">不符合要求</el-button>
			</div>
		</el-dialog>

		<el-dialog title="添加岗位" :visible.sync="showCreateDialog" append-to-body v-if="showCreateDialog" align="center"
			width="70%">

			<div class="dialog-create-ctr">
				<div class="row-ctr">
					<label>企业名称</label>
					<el-input v-model="companyName" placeholder="请输入企业名称" class="group-input" />
				</div>
				<div class="row-ctr">
					<label>岗位名称</label>
					<el-input v-model="jobName" placeholder="请输入岗位名称" class="group-input" />
				</div>
				<div class="row-ctr">
					<label>岗位描述</label>
					<el-input type="textarea" v-model="jobDescription" placeholder="请输入岗位名称" class="group-input"
						rows="8" />
				</div>
			</div>


			<div class="dialog-footer-job" align="center">
				<el-button type="primary" @click="clickConfirm()">确定</el-button>
				<el-button type="primary" class="el-button--warning" @click="clickCancel()">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		queryGroupJobData,
		queryGroupJobData2,
		queryPositionListByJob,
		createGroupCustomJob,
		delGroupCustomJob,
		calcuJobTypicalTask,
		exportGroupJobData
	} from "@/api/matrix"

	import {
		getSpanMap,
		isEmpty,
		convertList2Map
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				list: [],
				spanMap: {},
				params: {
					page: 1,
					pageSize: 20
				},
				jobParams: {
					page: 1,
					pageSize: 20,
					state: 'all',
					name: '',
					company: '',
					content: ''
				},
				total: 0,
				showCareerDialog: false,
				acceptMap: {},
				careerData: null,
				showCreateDialog: false,
				companyName: '',
				jobName: '',
				jobDescription: '',
				stateList: [{
					'state': 'all',
					'name': '全部'
				}, {
					'state': 'add',
					'name': '已添加'
				}],
				selectJobMap: {},
				tips: '',
				nameList: []
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.lastPageIndex = 1;
				this.requestData();
			},

			requestData() {
				this.groupId = this.$route.query.id;
				this.career_codes = this.$route.query.career_codes;
				this.params['career_codes'] = this.career_codes;
				this.params['group_id'] = this.groupId;
				queryGroupJobData2(this.params).then(res => {
					// console.log('groupId', this.groupId)
					let realData = res.data;
					this.list = realData.list;
					this.title = realData.title;
					this.sourceMap = convertList2Map(this.list, 'name');
					
					if(realData.acceptMap){
						this.acceptMap = realData.acceptMap;
					}
					
					if(realData.selectJobMap){
						this.selectJobMap = realData.selectJobMap;
					}
				});
			},

			clickNext() {
				let codeList = this.getSelectedCodes()

				if (codeList.length < 1) {
					Message({
						message: '岗位为空',
						type: 'error',
						zIndex: 300000
					})
					return;
				}
				

				let params = {
					'group_id': this.groupId,
					// 'categoryIds': JSON.stringify(codeList),
					'job_id_map': JSON.stringify(this.getSelectedJobIdMap())
				}
				calcuJobTypicalTask(params).then(res => {
					let id = res['data']['id']
					let path = '/typical_task?id=' + id;
					// console.log('path', path)
					this.$router.push(path);
				})
			},
			
			getSelectedJobIdMap(){
				let map = {}
				
				// console.log('getSelectedJobIdMap selectJobMap', this.selectJobMap)
				Object.keys(this.acceptMap).forEach(key => {
					
					if (this.acceptMap[key] == 1) {
						let itemSelectedMap = this.selectJobMap[key];
						
						map[key] = {
							'custom': itemSelectedMap['custom'],
							'list': []
						}
										
						// console.log('itemSelectedMap', itemSelectedMap)
						Object.keys(itemSelectedMap['map']).forEach(id => {
							let selectItem = itemSelectedMap['map'][id];
							// console.log('out id: ', id, 'selectItem', selectItem)
							if(selectItem['selected']){
								// console.log('push selectItem', selectItem)
								map[key]['list'].push({
									'custom': selectItem['custom'],
									'id': id
								})
							}
						})
					}
				})
				
				return map;
			},
			
			getCareerJobNum(name){
				let itemSelectedMap = this.selectJobMap[name];
				let num = 0;
				Object.keys(itemSelectedMap['map']).forEach(id => {
					let selectItem = itemSelectedMap['map'][id];
					// console.log('out id: ', id, 'selectItem', selectItem)
					if(selectItem['selected']){
						num++;
					}
				})
				
				// console.log('getCareerJobNum name', name, num);
				return num;
			},

			clickAccept(data) {
				
				let jobName = this.careerData.cateData.name;
				if (this.selectJobMap[jobName] == undefined) {
					let jobItem = this.sourceMap[jobName];
					
					this.selectJobMap[jobName] = {
						'custom': jobItem['custom'],
						'map': {}
					}
				}
					
				let num = 0;
				let hasFalse = false;
				
				let curMap = this.selectJobMap[jobName]['map'];
				
				Object.keys(curMap).forEach(key => {
					if(curMap[key]['selected']){
						hasFalse = true;
						num += 1;
					}
				})
					
				if (!hasFalse){
					this.tips = '请先选择岗位'
					// Message({
					// 	message: this.tips,
					// 	type: 'error',
					// 	zIndex: 9000000
					// })	
					
					Notification.error({
						title: this.tips
					})
					return;
				}
				
				let limitNum = 100;
				if(num > limitNum){
					this.tips = '最多选' + limitNum + '个岗位';
					// Message({
					// 	message: this.tips,
					// 	type: 'error',
					// 	zIndex: 9000000
					// })
					Notification.error({
						title: this.tips
					})
					return;
				}
				
				this.showCareerDialog = false;
				this.$set(this.acceptMap, data.name, 1)
				
				console.log('acceptMap', this.acceptMap)
				for(let i = 0; i < this.list.length; i++){
					
					let item = this.list[i];
					
					console.log('item.name', item.name, this.acceptMap[item.name])
					if (this.acceptMap[item.name] == 1){
						let count = this.getCareerJobNum(item.name);
						this.$set(this.list[i], 'count', count)
					}
				}
				
				// this.list = [...this.list]
				console.log('this.list', this.list)
			},

			clickReject(data) {
				let jobName = this.careerData.cateData.name;

				delete this.selectJobMap[jobName];
				
				this.showCareerDialog = false;
				this.$set(this.acceptMap, data.name, 2)
			},

			getSelectedCodes() {
				let list = []
				let map = convertList2Map(this.list, 'name')
				Object.keys(this.acceptMap).forEach(key => {
					if (this.acceptMap[key] == 1) {
						let item = map[key];
						list.push({
							'custom': item['custom'],
							'id': item['id']
						})
					}
				})
				
				console.log('list', list)

				return list;
			},

			clickIntro(row) {
				this.jobParams['code'] = row.code;
				this.jobParams['id'] = row.id;
				this.jobParams['name'] = '';
				this.jobParams['company'] = '';
				this.jobParams['content'] = '';
				this.jobParams['custom'] = row.custom;
				this.jobParams['career_codes'] = this.career_codes;
				this.jobParams['page'] = 1;
				this.jobParams['group_id'] = this.groupId;
				this.jobParams['state'] = 'all';
				
				this.queryJobData();
			},

			clickSearchJob() {
				this.jobParams['page'] = 1;
				this.queryJobData();
			},

			queryJobData() {
				if (this.careerData && this.careerData.list) {
					this.careerData.list = [];
				}
				
				if(this.jobParams.state == 'add'){
					let jobName = this.careerData.cateData.name;
					// this.selectJobMap[jobName]
					let jobIdList = [];
					// console.log('this.selectJobMap', this.selectJobMap)
					Object.keys(this.selectJobMap[jobName]['map']).forEach(key => {
						if (this.selectJobMap[jobName]['map'][key]['selected']) {							
							jobIdList.push(key)
						}
					})
					
					this.jobParams['job_ids'] = jobIdList.join(',');
				}
				
				queryPositionListByJob(this.jobParams).then(res => {
					let realData = res.data;
					this.careerData = realData;
					this.tips = '';
					this.showCareerDialog = true;
					
					if(this.jobParams['page'] == 1){
						this.nameList = realData.nameList;
					}
					
					this.$nextTick(() => {
						this.setDefaultSelection();
					})
				});
			},
			
			checkSelectable(row, index){
				return row.custom != 1;
			},

			clickCreate() {
				this.jobName = '';
				this.companyName = '';
				this.jobDescription = '';
				this.showCreateDialog = true;
			},

			clickConfirm() {
				let params = {
					'group_id': this.groupId,
					'name': this.jobName,
					'company': this.companyName,
					'description': this.jobDescription
				};

				createGroupCustomJob(params).then(res => {
					this.showCreateDialog = false;
					this.requestData();
				})
			},

			clickCancel() {
				this.showCreateDialog = false;
			},

			clickDel(name) {
				this.$confirm('确定删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let params = {
							'group_id': this.groupId,
							'name': name,
						};

						delGroupCustomJob(params).then(res => {
							this.requestData();
						});
						return true;
					});
			},

			handleSelectionChange(val) {
				if (this.isSettingDefault) {
					// 如果是设置默认选中，跳过业务逻辑
					console.log('正在设置默认选中，跳过处理')
					return
				}

				let jobName = this.careerData.cateData.name;

				if (this.selectJobMap[jobName] == undefined) {
					
					let jobItem = this.sourceMap[jobName];
					
					this.selectJobMap[jobName] = {
						'custom': jobItem['custom'],
						'map': {}
					}
				}
				// console.log('handleSelectionChange before val', val)
				// console.log('handleSelectionChange before this.selectJobMap', this.selectJobMap[jobName])
				this.careerData.list.forEach(row => {					
					let value = val.some(selected => selected.id === row.id && selected.custom == row.custom);
					this.selectJobMap[jobName]['map'][row.id] = {
						'selected': value,
						'custom': row.custom
					};
					// console.log('handleSelectionChange id', row.id, value)
				})
				// console.log('handleSelectionChange this.selectJobMap', this.selectJobMap[jobName])
			},

			setDefaultSelection() {
				this.isSettingDefault = true // 设置标志
				let jobName = this.careerData.cateData.name;
				if (this.selectJobMap[jobName] == undefined) {
					let jobItem = this.sourceMap[jobName];
					this.selectJobMap[jobName] = {
						'custom': jobItem['custom'],
						'map': {}
					}
				}

				let selectMap = this.selectJobMap[jobName]['map'];
				
				// console.log('setDefaultSelection selectJobMap', this.selectJobMap)
				// console.log('setDefaultSelection selectMap', selectMap)
				this.careerData.list.forEach(row => {
					
					let selected = false;
					
					for (const [key, item] of Object.entries(selectMap)) {
						if (item['selected'] && row.id == key && row.custom == item.custom) {
							this.$refs.multipleTable.toggleRowSelection(row, true)
							break;
						}
					}
				})

				// 使用 nextTick 确保所有选中操作完成后再重置标志
				this.$nextTick(() => {
					this.isSettingDefault = false
				})
			},
			
			clickExport() {
				let jobName = this.careerData.cateData.name;
				let map = this.selectJobMap[jobName];
				
				let list = []
				
				Object.keys(map).forEach(id => {
					if(map[id]){
						list.push(id)
					}
				})
				
				if(list.length < 1){
					Message({
						message: '请先选择岗位',
						type: 'error',
						zIndex: 300000
					})
					return;
				}
				
				let params = {
					'ids': list.join(',')
				}
				
				exportGroupJobData(params).then(res => {
					let realData = res.data;
			
					window.open(realData.url, '_blank')
				})
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "career_job.scss";
</style>